// 画面内の画像を待ち、ロゴの演出を最後まで再生してから本文を表示する。
export function initLoading() {
  const loading = window.ueharaLoading;
  const screen = document.querySelector('.js-loading');
  if (!loading || !screen) return Promise.resolve();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const delay = (duration) => new Promise(resolve => window.setTimeout(resolve, duration));

  function imageReady(image) {
    return image.decode().catch(function () {});
  }
  function backgroundReady(element, pseudo = null) {
    if (!element) return Promise.resolve();
    const background = window.getComputedStyle(element, pseudo).backgroundImage;
    const url = background.match(/url\(["']?(.*?)["']?\)/);
    if (!url) return Promise.resolve();
    const image = new Image();
    image.src = url[1];
    return imageReady(image);
  }

  // 表示中は背景の操作を止める。元からinertな要素は変更しない。
  Array.from(document.body.children).forEach(function (element) {
    if (element === screen || element.inert || ['SCRIPT', 'STYLE', 'LINK'].includes(element.tagName)) return;
    element.setAttribute('inert', '');
    element.setAttribute('data-loading-inert', '');
  });

  return new Promise(function (resolve) {
    // 画面が消えてから一呼吸置き、FVのコピーを表示する。
    document.addEventListener('loading:complete', async function () {
      if (!reducedMotion) await delay(150);
      resolve();
    }, { once: true });
    const images = Array.from(document.images).filter(function (image) {
      const rect = image.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && rect.top < window.innerHeight && rect.bottom > 0;
    });
    const artwork = Promise.all([
      imageReady(screen.querySelector('img')),
      backgroundReady(screen),
    ]);
    const page = Promise.all([
      ...images.filter(image => !screen.contains(image)).map(imageReady),
      backgroundReady(document.querySelector('.p-home-intro__background'), '::before'),
      backgroundReady(document.querySelector('.p-contact, .p-order, .p-not-found')),
      document.fonts ? document.fonts.ready : Promise.resolve(),
    ]);

    // ロゴは本文の読込を待たずに表示し、演出の1.4秒間を必ず確保する。
    const animation = Promise.race([artwork, delay(3000)]).then(async function () {
      if (!screen.isConnected) return;
      screen.classList.add('is-ready');
      await delay(reducedMotion ? 150 : 1400);
    });
    // 背面の重複背景を外し、1.2秒のフェードを終えてから本文の操作を戻す。
    Promise.all([animation, Promise.race([page, delay(5000)])]).then(async function () {
      if (!screen.isConnected) return;
      document.documentElement.classList.add('is-loading-revealing');
      screen.classList.add('is-leaving');
      await delay(reducedMotion ? 0 : 1200);
      if (screen.isConnected) loading.finish();
    });
  });
}
